<template>
  <div class="box">
    <div v-for="item in 4" :key="item">
      <img src="./jk.jpg" style="width: 100%; height: 100%" />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;

  div {
    width: 46%;
    height: 42%;
    margin: 2%;
    border: 1px solid #808080;
    border-radius: 3px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>